import { NavigateToScreenRequest } from '@ui-tool/core';
import { ScreenCodes } from '@mobile-data-access-enums';

export class ConcurrentSessionsAllowedNavigationRequest extends NavigateToScreenRequest<any> {
  //#region Constructor

  public constructor() {
    super(ScreenCodes.CONCURRENT_SESSIONS_ALLOWED);
  }

  //#endregion
}


